export const downloadBlob = (name, blob) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("download", name);

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const mimeToExtension = (mimeType) => {
  const map = {
    "application/pdf": "pdf",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/octet-stream": "docx",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      "xlsx",
    "text/plain": "txt",
    "image/jpeg": "jpg",
    "image/png": "png",
    "application/zip": "zip",
    "application/json": "json",
  };
  return map[mimeType] || ""; // fallback: stringa vuota
};
